import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Alert } from './ui/alert';
import { subirDocumentoPrueba } from '../lib/storage';

interface DocumentoUploadModalProps {
  open: boolean;
  onClose: () => void;
  pruebaNombre: string;
  rowId: string | number;
  nomId?: string;
  pedidoId: string;
  origenNumero: string;
  onUpload: (url: string) => void;
  documentoSubido?: boolean;
  urlDescarga?: string;
}

export function DocumentoUploadModal({
  open,
  onClose,
  pruebaNombre,
  rowId,
  nomId,
  pedidoId,
  origenNumero,
  onUpload,
  documentoSubido = false,
  urlDescarga
}: DocumentoUploadModalProps) {
  const [file, setFile] = useState<File | null>(null);
  const [confirm, setConfirm] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
      setError(null);
    }
  };

  const handleUpload = async () => {
    console.log('[DocumentoUploadModal] pruebaNombre:', pruebaNombre, 'rowId:', rowId, 'file:', file);
    if (!file) {
      setError('Selecciona un archivo para subir.');
      return;
    }
    if (!pruebaNombre || pruebaNombre === 'undefined') {
      setError('No se pudo determinar el nombre de la prueba.');
      return;
    }
    setLoading(true);
    try {
      const publicUrl = await subirDocumentoPrueba(file, pedidoId, origenNumero, rowId, nomId);
      setFile(null);
      setConfirm(false);
      setError(null);
      onUpload(publicUrl);
      onClose();
    } catch (err: any) {
      setError(err.message || 'Error al subir el documento.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {documentoSubido ? 'Documento subido' : 'Subir documento para la prueba'}
          </DialogTitle>
        </DialogHeader>
        {documentoSubido && urlDescarga ? (
          <div className="space-y-4">
            <Alert variant="success">Documento ya subido. Puedes descargarlo aquí:</Alert>
            <a href={urlDescarga} download className="text-blue-600 underline block">Descargar documento</a>
            <Button variant="outline" onClick={onClose}>Cerrar</Button>
          </div>
        ) : (
          <form
            onSubmit={e => {
              e.preventDefault();
              if (!confirm) setConfirm(true);
              else handleUpload();
            }}
            className="space-y-4"
          >
            <div>
              <label className="block font-medium mb-1">Archivo a subir</label>
              <Input type="file" accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/*" onChange={handleFileChange} disabled={loading} />
              {file && <div className="text-xs mt-1">Nombre: <b>{file.name}</b></div>}
            </div>
            {confirm && (
              <Alert variant="warning">
                ¿Estás seguro de que quieres subir este documento? No se podrá borrar ni editar después.
              </Alert>
            )}
            {error && <Alert variant="destructive">{error}</Alert>}
            <DialogFooter>
              <Button type="button" variant="outline" onClick={onClose} disabled={loading}>Cancelar</Button>
              <Button type="submit" variant="default" disabled={loading || !file}>
                {confirm ? (loading ? 'Subiendo...' : 'Confirmar subida') : 'Subir documento'}
              </Button>
            </DialogFooter>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
